import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useSecondaryButtonStyles = makeStyles({
    root: {
        fontWeight: tokens.fontWeightRegular,
        color: tokens.colorNeutralForeground1,
        backgroundColor: 'transparent',
        ...shorthands.borderWidth(tokens.strokeWidthThick),
        ...shorthands.borderRadius(tokens.borderRadiusLarge),
        ...shorthands.borderColor(tokens.colorNeutralForeground1),
        ':hover': {
            color: tokens.colorNeutralBackground4,
            backgroundColor: tokens.colorNeutralBackgroundInverted,
            ...shorthands.borderColor('transparent'),
            ...shorthands.borderWidth(tokens.strokeWidthThick)
        },
        ':disabled': {
            backgroundColor: tokens.colorNeutralBackgroundDisabled,
            color: tokens.colorNeutralForegroundDisabled,
            ...shorthands.borderColor(tokens.colorNeutralStrokeDisabled),
            ':hover': {
                cursor: 'default',
                backgroundColor: tokens.colorNeutralBackgroundDisabled,
                color: tokens.colorNeutralForegroundDisabled,
                textShadow: 'unset',
                ...shorthands.borderColor(tokens.colorNeutralStrokeDisabled)
            }
        }
    }
});

export default useSecondaryButtonStyles;
